import {Button, Modal} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {Formik, Form} from "formik";
import {IconButtonSave} from "../../../../component/IconSvg";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import { OctGenerateForm } from "@oceantech/oceantech-ui";
import {TYPE_KE_HOACH_DAO_TAO} from "../constants/constansKeHoach";

interface Props {
  show: boolean;
  onHide: () => void;
  onOk?: (value?: any, source?: string) => void;
  initialValues: any;
  type: TypeKeHoach;
}

const DialogPhieuKhaoSat = (props: Props) => {
  const {
    show, onHide, initialValues, type, onOk = () => {
    }
  } = props;
  const {setIsLoading} = useContext(AppContext);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values,
    };
    onOk(dataSubmit, type.code)
    onHide()
    // try {
    //   setIsLoading(true);
    //   const id = values.keHoach?.id;
    //   const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
    //   if (CODE.SUCCESS === data?.code) {
    //     setIsView(true);
    //     setDetailPhieuKeHoach({
    //       ...data?.data,
    //     });
    //     toast.success(((id) ? "Cập nhật" : "Thêm") + " kế hoạch thành công");
    //   } else {
    //     let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
    //     toast.warning(errorMesage);
    //     setIsLoading(false);
    //   }
    // } catch (error) {
    //   setIsLoading(false);
    //   toast.warning("Xảy ra lỗi, vui lòng thử lại!");
    //   console.error(error);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  useEffect(() => {
    updateFormVatTu();
  }, []);

  const updateFormVatTu = async () => {
    const data = await generateForm(type.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT({...generateInitValues(data), ...(initialValues?.[type.code] ?? {})});
  };
  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{[type.code]: initialValuesFormThemVT}}
        validationSchema={generateValidationSchema(listJsonGenerateVT, type.code)}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide}
                           title={type?.name}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <OctGenerateForm
                    isView={false}
                    listFieldAuto={listJsonGenerateVT}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    setFieldValue={setFieldValue}
                    modelID={type.code}
                    customComponent={DynamicComponent}
                  />
                  <div className="spaces mt-10 pb-10 d-flex justify-content-end w-100 bg-white spaces">
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                      <IconButtonSave/> {values?.[type.code]?.id ? `Cập nhật` : `Thêm`}
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogPhieuKhaoSat;
